import AdminHeader from '../components/common/AdminHeader';
import UserManagementComponent from '../components/users/UserManagement';

export default function UserManagement() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <UserManagementComponent />
      </main>
    </div>
  );
}
